import { QueryFunctionContext } from '@tanstack/react-query'
import { GetCompaniesReturnType, getCompanies } from 'API/companyService'
import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore'
import { Company } from 'resources/types'
import { AllowedOverrides } from './queryOptionsUtils.types'

export type getCompaniesOptions = {
	companyIDs: string[]
};

export const queryKey = 'companies'

const getCompaniesQueryOptions = ({
	companyIDs,
}: getCompaniesOptions,
overrides?: AllowedOverrides) => ({
	queryKey: [
		queryKey, {
			companyIDs,
		},
	],
	queryFn: async (context: QueryFunctionContext): Promise<GetCompaniesReturnType<Company>> => {
		const pageParam = context.pageParam as QueryDocumentSnapshot<DocumentData> | undefined
		const result = await getCompanies(companyIDs, pageParam)
		return result
	},
	getNextPageParam: (lastPage: GetCompaniesReturnType<Company>) => {
		// If limitNumber is undefined, assume there's no limit and always return lastDocument
		return lastPage.lastDocument || null
	},
	initialPageParam: undefined,
	// safe overrides
	staleTime: 30 * 1000, // Default stale time is 30 seconds
	...overrides,
})

export default getCompaniesQueryOptions
